import { prefixerI } from './common'

export const ROUTE_INFORME_ACTIVO_FIJO_X_TIPO = prefixerI('activo-fijo-x-tipo')
export const ROUTE_INFORME_ACTIVO_FIJO_CON_ALTA_CONTABLE = prefixerI('activo-fijo-con-alta-contable')
export const ROUTE_INFORME_ACTIVO_FIJO_SIN_ALTA_CONTABLE = prefixerI('activo-fijo-sin-alta-contable')
export const ROUTE_INFORME_DEPRECIACION_ACTIVOS_FIJOS = prefixerI('depreciacion-activos-fijos')
export const ROUTE_INFORME_AVALUOS = prefixerI('avaluos')
